import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ObsidiamJweComponent } from 'projects/obsidiam-jwe/src/public-api';

declare var $: any;
// declare var initGeetest: any;
declare var grecaptcha: any;

@Component({
   selector: 'app-login',
   templateUrl: './login.component.html',
   styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
   isLoading: any = 2;
   user: any = {};
   errors: any = {
      email: '', password: ''
   };
   errorArr: any = 0;
   validationMessages: any = {};
   ipInfo: any;
   authError: any = '';
   gtObj: any;
   constructor(private authService: AuthService,
      private cookieService: CookieService,
      private obsidiamJweComponent: ObsidiamJweComponent,
      private route: Router
   ) {
      // if (this.authService.isLoggedIn) {
      //    this.route.navigate(['/dashboard']);
      // }
      
      this.user.source = 'Website';
      this.user.browser = this.authService.getBrowserName();

   }
   ngOnInit() {
      const $this = this;
      $('#login-form input').on('keyup', function () {
         $this.onChange($(this).attr('name'));
      });
   }

   login() {
      this.authError = '';
      this.isLoading = 1;
      // console.log(this.user)
      this.obsidiamJweComponent.encodeJwe(true, this.user, resEnc => {
      this.authService.login(resEnc).toPromise().then((m: any) => {
         this.isLoading = 2;
         if (m.status === 200) {
            // debugger
            let dataUser={
               bankId: m.data.bankId,
               projectId: m.data.projectId
            }
            localStorage.setItem('userInfo', JSON.stringify(m['data'] || {}));
            location.href = '/2f-authentication';
            localStorage.setItem('dataInfo', JSON.stringify(dataUser));
         } else {
            this.authError = m['message'];
         }
      });
   });
   }
   //  checkCaptcha() {
   //     if (this.validate(true)) {
   //        this.login();
   //     }
   //  }
   checkLoading() {
      console.log(this);
      this.isLoading = this.isLoading;
   }

   checkCaptcha() {
      if (this.validate(true)) {
         grecaptcha.ready(() => {
            grecaptcha.execute(environment.google_captcha, { action: 'login' }).then((token) => {
               this.user.recaptchaToken = token;
               this.login();
            });
         });
      }
   }

   // loadCaptcha() {
   //    this.authService.geetestRegister().subscribe((m: any) => {
   //       if (m.success === 1) {
   //          this.isLoading = 2;
   //          initGeetest({
   //             gt: m.gt,
   //             width: '100%',
   //             challenge: m.challenge,
   //             new_captcha: m.new_captcha,
   //             product: 'bind',
   //             offline: !m.success,
   //             // https: true,
   //             lang: 'en'
   //          }, (captchaObj) => {
   //             console.log(this);
   //             this.gtObj = captchaObj;
   //             // captchaObj.appendTo('#embed-captcha');
   //             captchaObj.onSuccess(() => {
   //                // this.isLoading = 2;
   //                console.log('success');
   //                if (this.gtObj.getValidate()) {
   //                   this.login();
   //                } else {
   //                   this.gtObj.verify();
   //                }
   //             });
   //             captchaObj.onReady(() => {
   //                // $('#wait')[0].className = 'hide';
   //                console.log('ready');
   //             });
   //          });
   //       }
   //    });
   // }
   validate(isSubmit) {
      const err: any = {};
      this.errorArr = 0;
      this.errors = {};
      this.validateEmail(isSubmit, '');
      return this.errorArr > 0 ? false : true;
   }
   validateEmail(isSubmit, textinputName) {
      // tslint:disable-next-line: max-line-length
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (isSubmit || textinputName === 'email') {
         if (!this.user.username) {
            this.errors.email = 'login.validation.emailCanNotBlank';
            this.errorArr = this.errorArr + 1;
         }
         if (this.user.username && !emailRegex.test(this.user.username)) {
            this.errors.email = 'login.validation.enterValidEmailAdd';
            this.errorArr = this.errorArr + 1;
         }
      }
      this.validatePassword(isSubmit, textinputName);

   }
   validatePassword(isSubmit, textinputName) {
      if (isSubmit || textinputName === 'password') {
         if (!this.user.password) {
            this.errors.password = 'login.validation.passNotBlank';
            this.errorArr = this.errorArr + 1;
         }
         if (this.user.password && this.user.password.length < 8) {
            this.errors.password = 'login.validation.passBtw8To16';
            this.errorArr = this.errorArr + 1;
         }
      }
   }
   onChange(name) {
      this.errors[name] = '';
      this.validateEmail(false, name);
   }
}
